import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform  {

  transform(value: string, length: number): string {
    const trail = '...';
    return value.length > length ? value.substring(0, length) + trail : value;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/truncate-pipe/truncate.pipe.ts